import { CategoryDetailsPageContext } from "@NA/Overrides/Pages/CategoryDetailsPage";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { FC } from "react"; 
import { connect } from "react-redux";
import { css } from "styled-components";
import { getPaginationMessage } from "@NA/Utils/Utility";


interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    const pagination = getProductListDataViewProperty(state, "pagination");
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");
    const { productFilters } = state.pages.productList;

    return {
        totalItemCount: pagination?.totalItemCount,
        query: correctedQuery || productFilters.query,
        pagination,
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface ProductListProductCountStyles {
    wrapper?: InjectableCss;
    countText?: TypographyPresentationProps;
    itemsText?: TypographyPresentationProps;
    queryText?: TypographyPresentationProps;
    showingText?: InjectableCss;
}

export const productCountStyles: ProductListProductCountStyles = {
    countText: {
        css: css`
            white-space: nowrap;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
        `,
    },
    queryText: {
        css: css`
            white-space: nowrap;
            font-weight: bold;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 15px;
                    `,
                    css`
                        margin-left: 15px;
                    `,
                    css`
                        margin-left: 0px;
                    `,
                    css`
                        margin-left: 0px;
                    `,
                    css`
                        margin-left: 15px;
                    `,
                ])}
        `,
    },
    showingText: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            display: none;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

const styles = productCountStyles;


const ProductListProductCount: FC<Props> = ({ totalItemCount, query, pagination }) => {
    if (!totalItemCount || !pagination) {
        return null;
    }

    const itemsText = (totalItemCount !== 1 ? " items" : " item") + (query ? " for " : "");
   
    //commented below code for - ADINA-52018 
    /*
    const startOptions = () => {
        if (pagination!.page === 1) {
            return 1;
        } else {
            return Number(pagination!.page - 1) * Number(pagination!.pageSize) + 1;
        }
    };

    const endOptions = () => {
        const pageSize =
            Number(pagination!.pageSize) % Number(pagination!.defaultPageSize) == 0
                ? Number(pagination!.pageSize)
                : Number(pagination!.pageSize) + 1;
        var countNumber = Number(pagination!.page) * Number(pageSize);
        if (countNumber < pagination!.totalItemCount) {
            if (pagination!.page > 1) {
                return Number(pagination!.page) * Number(pageSize) - 1;
                } else {
                return Number(pagination!.page) * Number(pageSize);
            }
        } else {
            return pagination!.totalItemCount;
        }
    };
   
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.countText} data-test-selector="productListCountText">
                <Typography {...styles.showingText}>{"Showing"}&nbsp;</Typography>
                {`${startOptions()} - ${endOptions()} of ${totalItemCount}`}
            </Typography>
        </StyledWrapper>
    );
    */

    //PLP per page selection results count fix - ADINA-52018 
    const page =pagination.page;
    const pageSize = pagination.pageSize;   
    
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.countText} data-test-selector="productListCountText">
                <Typography {...styles.showingText}>{"Showing"}&nbsp;</Typography>
                {getPaginationMessage(page, pageSize, totalItemCount)}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListProductCount),
    definition: {
        group: "Product List",
        displayName: "Product List Count",
        allowedContexts: [ProductListPageContext, CategoryDetailsPageContext],
    },
};

export default widgetModule;
